import React, { Component } from "react";

class ActivityIndicator extends Component {
    render() {
        return (
            <div className="s360-activity-indicator-container">
                <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }
}

export default ActivityIndicator;